// extracted by mini-css-extract-plugin
module.exports = {"banner":"recorder-download-banner_banner_3Sb"};